var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "civilian" }, [
    _c(
      "div",
      { staticClass: "civilian_left" },
      [
        _c("dialogCenter", {
          attrs: {
            productType: 3,
            dialogData: _vm.alarm_detail,
            deviceData: _vm.device_data
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "civilian_right" },
      [
        _c("dialogLeft", {
          attrs: {
            dialogData: _vm.mes_data,
            position_item: _vm.position_item,
            productType: 3
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ba3dc59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba3dc59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialog_industrial.vue
// module id = null
// module chunks = 